export const getStyles = () => {
  return {
    socialMediaIcon: {
      color: '#094e99',
      fontSize: '1rem',
      lineheight: 1,
      margin: '0rem',
    },
  }
}
